// useColorScale.ts
import { useState } from "react";
import { AlertColor } from "@mui/material/Alert";

export const useColorScale = () => {
  const [severity, setSeverity] = useState<AlertColor>("success");
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [testMessage, setTestMessage] = useState<string>("Testing alert");
  const [isColorPopoverOpen, setColorPopOverOpen] = useState<boolean>(false);
  const [minOrMaxColor, setminOrMaxColor] = useState<string>("");
  const [color, setColor] = useState<string>("");
  const [isCalendarColorPopoverOpen, setCalendarColorPopOverOpen] =
    useState<boolean>(false);
  const [colorPickerFor, setColorPickerFor] = useState<string>("");

  const checkMinMaxValue = (min: number, max: number) => {
    if (Number(max) === 0) {
      showAlert("error", "Max value can't be zero");
      return false;
    } else if (Number(min) >= Number(max)) {
      showAlert("error", "Max value should be greater than Min");
      return false;
    }
    return true;
  };

  const showAlert = (severity: AlertColor, message: string) => {
    setSeverity(severity);
    setTestMessage(message);
    setOpenAlert(true);
  };

  return {
    severity,
    openAlert,
    testMessage,
    isColorPopoverOpen,
    minOrMaxColor,
    color,
    isCalendarColorPopoverOpen,
    colorPickerFor,
    setColorPopOverOpen,
    setminOrMaxColor,
    setColor,
    setCalendarColorPopOverOpen,
    setColorPickerFor,
    checkMinMaxValue,
    showAlert,
    setOpenAlert,
    setTestMessage,
  };
};